/** Region-aware display for digital product prices (mirrors credit pack formatting). */

export function formatProductPrice(product, pricingRegion) {
  if (!product) return '';
  if (pricingRegion === 'PAYSTACK') {
    const ngn = product.price_ngn ?? 0;
    return `₦${(ngn / 100).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;
  }
  const usd = product.price_usd ?? 0;
  return `$${(usd / 100).toFixed(2)}`;
}

export function defaultPricingRegion(user) {
  return user?.pricing_region || 'PAYSTACK';
}
